// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ReactNode, type ReactElement, type ComponentProps } from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button/standard-button';
// @ts-expect-error - TS2614 - Module '"@atlaskit/dynamic-table"' has no exported member 'RowType'. Did you mean to use 'import RowType from "@atlaskit/dynamic-table"' instead?
import type { RowType } from '@atlaskit/dynamic-table';
import { isActorInvitedUser } from '../../common/utils';
import { MAX_RESULTS_PER_PAGE } from '../../controllers/table-controller/constants';
import MentionItem from './mention-item';
import RoleCell from './role-cell';
import type { CreateActorRowParams, DumbTableProps } from './types';

export const createActorRowType = ({
	hasPermissionsGate,
	applicationName,
	projectRoles,
	removeButtonText,
	onSelectActorToRemove,
	onRolesUpdated,
	actor,
}: CreateActorRowParams): RowType => ({
	cells: [
		{
			content: <MentionItem actor={actor} />,
			key: MAX_RESULTS_PER_PAGE, // Passing the same key to avoid sorting by DynamicStateless Table
		},
		{
			content: <EmailContainer>{actor.email || '-'}</EmailContainer>,
		},
		{
			content: (
				<RoleCell
					hasPermissionsGate={hasPermissionsGate}
					applicationName={applicationName}
					actor={actor}
					projectRoles={projectRoles}
					onRolesUpdated={onRolesUpdated}
				/>
			),
		},
		{
			content:
				!isActorInvitedUser(actor) && !hasPermissionsGate ? (
					<Button
						aria-label={`Remove ${actor.displayName}`}
						spacing="none"
						appearance="link"
						// @ts-expect-error - TS2322 - Type '{ children: string; spacing: "none"; appearance: "link"; externalId: string; onClick: () => void; }' is not assignable to type 'IntrinsicAttributes & ButtonProps & RefAttributes<HTMLElement>'.
						externalId="users-and-roles.actor-open-confirmation"
						onClick={() => {
							onSelectActorToRemove(actor);
						}}
					>
						{removeButtonText}
					</Button>
				) : null,
		},
	],
});

export const shouldDisplayIntro = (
	accessType: DumbTableProps['accessType'],
	actors: DumbTableProps['actors'],
	isTableReset: boolean,
	isFetching: boolean,
): boolean => {
	if (!isFetching && !isTableReset && accessType && actors && actors.length === 1) {
		return accessType.value.toLowerCase() !== 'open';
	}
	return false;
};

export const isNameSortable = (
	pageNumber: number,
	isLastPage: boolean,
	actorsLength: number,
): boolean => (pageNumber === 1 && actorsLength > 1 ? isLastPage : false);

// This utility will convert Node to an Element Type as many functions like shallow/mount except Element rather than Node
export const contentWithElementType = <T,>(
	element: ReactNode,
	component: T,
	// @ts-expect-error - TS2344 - Type 'T' does not satisfy the constraint 'keyof IntrinsicElements | JSXElementConstructor<any>'.
): ReactElement<ComponentProps<T>> => {
	// @ts-expect-error - TS2344 - Type 'T' does not satisfy the constraint 'keyof IntrinsicElements | JSXElementConstructor<any>'.
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const content = element as ReactElement<ComponentProps<typeof component>>;
	return content;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const EmailContainer = styled.div<{
	children?: ReactNode;
}>({
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	maxWidth: '300px',
	whiteSpace: 'nowrap',
});
